import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { submitPartnerNotification } from "../../../../../api/Api";
import { getFromLocalStorage } from "../../../../../utils/common-utils";
import "../partnerNotificationTabs.css";

const EditPartnerNotification = ({ editData, onUpdate }) => {
  const [notificationData, setNotificationData] = useState({
    notifyUrl: "",
    lpUrl: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (editData) {
      setNotificationData(prev => ({
        ...prev,
        notifyUrl: editData.notifyUrl || "",
        lpUrl: editData.lpUrl || ""
      }));
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNotificationData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    // Validation checks
    const errors = [];
    if (!notificationData.notifyUrl) {
      errors.push("Notify URL is required");
    } else if (!validateUrl(notificationData.notifyUrl)) {
      errors.push("Please enter a valid Notify URL");
    }

    if (!notificationData.lpUrl) {
      errors.push("Landing Page URL is required");
    } else if (!validateUrl(notificationData.lpUrl)) {
      errors.push("Please enter a valid Landing Page URL");
    }

    if (errors.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: errors.join("<br>"),
      });
      return;
    }

    try {
      const payload = {
        id: editData?.id,
        userId: getFromLocalStorage("userData")?.id,
        serviceId: editData?.serviceId,
        notifyUrl: notificationData.notifyUrl,
        lpUrl: notificationData.lpUrl,
      };

      const response = await submitPartnerNotification(payload);

      if (response?.statusDescription?.status === 200) {
        onUpdate(response.productModel);
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description || "Partner notification details updated successfully!",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response?.statusDescription?.description || "Failed to update partner notification details",
        });
      }
    } catch (error) {
      console.error("Error updating partner notification details:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to update partner notification details",
      });
    }
  };

  return (
    <div className="tab-content-section">
      <div className="tab-content">
        <div className="tab-pane active">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Notify Url<span className="text-danger">*</span></label>
                  <input
                    type="url"
                    className={`form-control ${isSubmitted && !notificationData.notifyUrl ? 'is-invalid' : ''}`}
                    name="notifyUrl"
                    value={notificationData.notifyUrl}
                    onChange={handleChange}
                    placeholder="Enter Notify Url"
                    maxLength={500}
                    required
                  />
                  {isSubmitted && !notificationData.notifyUrl && (
                    <div className="invalid-feedback">
                      Notify URL is required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Landing Page Url<span className="text-danger">*</span></label>
                  <input
                    type="url"
                    className={`form-control ${isSubmitted && !notificationData.lpUrl ? 'is-invalid' : ''}`}
                    name="lpUrl"
                    value={notificationData.lpUrl}
                    onChange={handleChange}
                    placeholder="Enter LP Url"
                    maxLength={500}
                    required
                  />
                  {isSubmitted && !notificationData.lpUrl && (
                    <div className="invalid-feedback">
                      Landing Page URL is required
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12  buttons_divs">
                <button
                  type="submit"
                  className="btn btn-primary float-right"
                >
                  Update Partner Notification
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditPartnerNotification;


